import React from 'react'
import PortableText from "./portableText";

const Body = blocks => (
  blocks.blocks && <PortableText portableTextContent={blocks.blocks} />
)

export default Body